import { render } from "./latest-receive.vue?vue&type=template&id=0255df00&scoped=true"
import script from "./latest-receive.vue?vue&type=script&lang=js"
export * from "./latest-receive.vue?vue&type=script&lang=js"

import "./latest-receive.vue?vue&type=style&index=0&id=0255df00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0255df00"]])

export default __exports__